import React from 'react';

import FormikSlider from 'src/components/formik-slider';

interface Props {
  closePopover: () => void;
}

const NumberGradePicker = ({closePopover}: Props) => (
  <div className="course-number-grade-picker">
    <FormikSlider
      name="grade.gradeInput"
      min={0}
      max={100}
      onChangeCommitted={closePopover}
      valueLabelDisplay="on"
    />
  </div>
);

export default NumberGradePicker;
